<template>
	<div class="admin-sidebar d-flex align-start justify-start flex-column white--text">
		<div class="w-100 px-4 pt-6 pb-3">
			<a href="/">
				<img src="../../assets/logo.svg" alt="logo" style="width: 120px" />
			</a>
		</div>

		<div class="w-100 name-wrap pa-4">
			<div class="d-flex align-center justify-start">
				<div class="mr-3 flex-center">
					<img :src="user.photo_url" class="admin-avatar" v-if="user.photo_url" alt="avatar" />
					<div v-else class="admin-avatar flex-center">
						{{ user.name.charAt(0) }}
					</div>
				</div>

				<div class="d-flex align-start justify-start flex-column">
					<span class="small-text white--text" style="margin-bottom: 2px">{{ user.name }}</span>
					<span class="smaller-text blue-text">{{ user.roles[0].name }}</span>
				</div>

				<v-btn icon class="ml-auto" @click="logout" title="Logout" variant="plain">
					<v-icon color="error">mdi-logout</v-icon>
				</v-btn>
			</div>
		</div>

		<v-list
			class="w-100 py-0 admin-list"
			theme="dark"
			style="background: transparent !important; border-top: 1px solid #958fc520">
			<v-divider></v-divider>
			<v-list-item href="/admin" :active="activePath === 'admin'">
				<v-list-item-title class="d-flex align-center justify-start small-text admin-link">
					<v-icon size="small" class="mr-3">mdi-view-dashboard</v-icon>

					Dashboard
				</v-list-item-title>
			</v-list-item>
			<v-divider></v-divider>
			<template v-for="item in items" :key="item.name">
				<v-list-item :href="item.url" :active="fullPath === item.url">
					<v-list-item-title class="d-flex align-center justify-start small-text admin-link">
						<v-icon size="small" class="mr-3">{{ item.icon }}</v-icon>

						{{ item.name }}
					</v-list-item-title>
				</v-list-item>

				<v-divider></v-divider>
			</template>
		</v-list>

		<div class="w-100 py-4" v-if="user.roles[0].name === 'superadmin'">
			<v-btn class="normal-spacing" variant="plain" color="warning" @click="bulkCancelOld">
				<v-icon class="mr-3">mdi-alert</v-icon>
				Purge old Prices
			</v-btn>
		</div>
	</div>
</template>

<script>
	import axios from "axios"
	export default {
		name: "AdminSidebar",
		props: {
			items: Array,
			activePath: String,
			fullPath: String,
			user: Object,
			csrf: String,
		},
		methods: {
			logout() {
				axios
					.post("/api/v1/auth/admin-logout")
					.then((response) => {
						window.location.reload()
					})
					.catch((error) => {
						console.log(error)
					})
			},
			migrateStripe() {
				axios
					.post(
						`/admin/migrate-subscribers`,
						{},
						{
							headers: {
								"X-CSRF-TOKEN": this.csrf,
							},
						},
					)
					.then(() => {
						alert("Migration successful! Redirecting to prices page...")
						window.location = `/admin/prices`
					})
					.catch((err) => console.error(err))
			},
			bulkCancelOld() {
				if (confirm("Are you sure you want to cancel all old subscriptions? This action cannot be undone.")) {
					axios
						.post(
							`/admin/purge-old-prices`,
							{},
							{
								headers: {
									"X-CSRF-TOKEN": this.csrf,
								},
							},
						)
						.then(() => {
							alert("Purged.")
						})
						.catch((err) => console.error(err))
				}
			},
		},
	}
</script>

<style lang="scss">
	.admin-sidebar {
		background: #0e0818;
		width: 250px;
		height: 100vh;
		border-right: 1px solid #958fc520;
		z-index: 5;
		overflow-y: auto;
		transition: all 0.3s ease;
		position: fixed;

		* {
			transition: all 0.3s ease;
		}
	}

	.admin-avatar {
		background: #6b96c250;
		color: #fff;
		width: 32px;
		height: 30px;
		object-fit: cover;
		border-radius: 50%;
		border: 1px solid #ffffff50;
	}

	.name-wrap {
		border-top: 1px solid #958fc550;
	}

	@media (max-width: 768px) {
		.admin-sidebar {
			margin-left: -250px;
		}
	}
</style>
